import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
} from "@mui/material";

const DEMO_IMAGES = [
  "013AjtbpHVyf", "013AkPNRPrZ6", "04RW1dGddh", "013Aitiph5CK",
  "013Aitiph5CL", "013Aitiph5CM", "013AkPNRPrhv", "013Aiu4aiAzs",
  "013Aiu4UmDep", "013Aitiph584", "013Aiu4UmDaY", "013Aitiph5CR",
];

const DEMO_VIDEOS = [
  { id: "019EE8EBk2fP8", label: "Demo Video 1" },
  { id: "013Aiu4aiAmc", label: "Demo Video 2" },
  { id: "013Aitiph5Gp", label: "Demo Video 3" },
  { id: "013Aiu4UmDog", label: "Demo Video 4" },
];

export const DemoMediaLibraryModal = ({ open, mediaType = "image", onClose, onSelect }) => {
  const [customId, setCustomId] = useState("");
  const isVideo = mediaType === "video";

  const handleSelect = (id) => {
    if (onSelect) onSelect(id);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {isVideo ? "Velg bakgrunnsvideo (Demo)" : "Velg bilde fra DigitaltMuseum (Demo)"}
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 2, display: "flex", gap: 1 }}>
          <TextField
            size="small"
            fullWidth
            placeholder={isVideo ? "Skriv inn video DMS-ID / URL" : "Skriv inn bilde DMS-ID"}
            value={customId}
            onChange={(e) => setCustomId(e.target.value)}
          />
          <Button
            variant="contained"
            disabled={!customId.trim()}
            onClick={() => handleSelect(customId.trim())}
          >
            Bruk
          </Button>
        </Box>

        {isVideo ? (
          <Box sx={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 2 }}>
            {DEMO_VIDEOS.map((vid) => (
              <Box
                key={vid.id}
                onClick={() => handleSelect(vid.id)}
                sx={{
                  p: 2,
                  border: "1px solid #ccc",
                  borderRadius: 1,
                  cursor: "pointer",
                  "&:hover": { borderColor: "#4484F1", bgcolor: "#f5f9ff" },
                }}
              >
                <Typography variant="subtitle2" fontWeight="bold">{vid.label}</Typography>
                <Typography variant="caption" color="text.secondary">ID: {vid.id}</Typography>
              </Box>
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
              gap: 1.5,
            }}
          >
            {DEMO_IMAGES.map((id) => (
              <Box
                key={id}
                onClick={() => handleSelect(id)}
                sx={{
                  position: "relative",
                  aspectRatio: "1/1",
                  borderRadius: 1,
                  overflow: "hidden",
                  cursor: "pointer",
                  border: "2px solid transparent",
                  "&:hover": { borderColor: "#4484F1" },
                }}
              >
                <img
                  src={`https://ems.dimu.org/image/${id}?dimension=400x400`}
                  alt={id}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  loading="lazy"
                />
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Avbryt</Button>
      </DialogActions>
    </Dialog>
  );
};
